import { Box, TextField } from '@mui/material';
import { ICaseDetailsInputs } from 'API';
import { TextareaCounter } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext, useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { generateError } from 'Regex';
import { validateLettersNumbersAndSpacialChars } from 'Utils/validateLettersNumbersAndSpacialChars';

export const UnknownWitnesses = () => {
  const { index } = useContext(IndexContext);
  const {
    register,
    formState: { errors },
  } = useFormContext<ICaseDetailsInputs>();

  const [textAreaWitnessDetails, setTextAreaWitnessDetails] =
    useState<string>('');

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const otherWitnessesDetailsServiceError = errors.caseDetails
    ? errors.caseDetails[index]
    : undefined;

  const otherWitnessesDetails = useWatch({
    name: `caseDetails.${index}.otherWitnessesDetails`,
  });

  useEffect(() => {
    if (otherWitnessesDetails) setTextAreaWitnessDetails(otherWitnessesDetails);
  }, [otherWitnessesDetails]);

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <TextField
        id={`${dictionary.fourthSectionWitnessDetails}-${index}`}
        label={dictionary.fourthSectionWitnessDetails}
        sx={{
          mt: '20px',
        }}
        inputProps={{
          maxLength: '500',
        }}
        {...register(
          `caseDetails.${index}.otherWitnessesDetails` as `caseDetails.0.otherWitnessesDetails`
        )}
        multiline
        rows={6}
        onChange={(event: any) => {
          setTextAreaWitnessDetails(event.target.value);
          validateLettersNumbersAndSpacialChars(event);
        }}
        role={
          Boolean(otherWitnessesDetailsServiceError?.otherWitnessesDetails)
            ? 'alert'
            : undefined
        }
        error={Boolean(
          otherWitnessesDetailsServiceError?.otherWitnessesDetails
        )}
        helperText={
          Boolean(
            otherWitnessesDetailsServiceError?.otherWitnessesDetails?.message
          ) &&
          generateError(
            dictionary.fourthSectionWitnessDetails,
            otherWitnessesDetailsServiceError?.otherWitnessesDetails?.message!
          )
        }
      />
      <TextareaCounter
        counter={textAreaWitnessDetails.length}
        limit={500}
        hasError={Boolean(
          otherWitnessesDetailsServiceError?.otherWitnessesDetails?.message
        )}
      />
    </Box>
  );
};
